export default {
    upImgSrc: '/api/dsicm-contact-platform/feign/file/upload',
    payTypeConfig: [{
            label: '微信支付',
            value: 1,
        },
        {
            label: '支付宝',
            value: 2,
        },
        {
            label: '线上支付',
            value: 3,
        },
        {
            label: '套餐权益抵扣',
            value: 4,
        },
        {
            label: '优惠卷抵扣',
            value: 5,
        },
    ],
    timeArr: [{
            label: "1",
            val: "1"
        },
        {
            label: "2",
            val: "2"
        },
        {
            label: "3",
            val: "3"
        },
        {
            label: "4",
            val: "4"
        },
        {
            label: "5",
            val: "5"
        },
        {
            label: "6",
            val: "6"
        },
        {
            label: "7",
            val: "7"
        },
        {
            label: "8",
            val: "8"
        },
        {
            label: "9",
            val: "9"
        },
        {
            label: "10",
            val: "10"
        }
    ],
    hourlyBasis: [{
            label: "秒",
            val: "1"
        },
        {
            label: "分",
            val: "2"
        },
        {
            label: "时",
            val: "3"
        },
        {
            label: "日",
            val: "4"
        },
        {
            label: "周",
            val: "5"
        },
        {
            label: "月",
            val: "6"
        },
        {
            label: "年",
            val: "7"
        }
    ],
    aroundBasis: [{
            label: "后",
            val: "1"
        },
        {
            label: "内",
            val: "2"
        },
        {
            label: "前",
            val: "4"
        }
    ],
    qualitative: [{
            label: "秒",
            val: "1"
        },
        {
            label: "分",
            val: "2"
        },
        {
            label: "时",
            val: "3"
        },
        {
            label: "日",
            val: "4"
        },
        {
            label: "周",
            val: "5"
        },
        {
            label: "月",
            val: "6"
        },
        {
            label: "年",
            val: "7"
        },
        {
            label: "毫升",
            val: "8"
        },
        {
            label: "升",
            val: "9"
        },
        {
            label: "毫米",
            val: "10"
        },
        {
            label: "厘米",
            val: "11"
        },
        {
            label: "分米",
            val: "12"
        },
        {
            label: "米",
            val: "13"
        },
        {
            label: "千米",
            val: "14"
        },
        {
            label: "mmol/L",
            val: "15"
        },
        {
            label: "岁",
            val: "16"
        },
        {
            label: "",
            val: "17"
        }
    ],
    symbolArr: [{
            label: ">",
            val: "1"
        },
        {
            label: "≥",
            val: "2"
        },
        {
            label: "=",
            val: "3"
        },
        {
            label: "<",
            val: "4"
        },
        {
            label: "≤",
            val: "5"
        },
        {
            label: "≠",
            val: "6"
        }
    ],
    determineArr: [{
            label: "+",
            val: "1"
        },
        {
            label: "-",
            val: "2"
        },
        {
            label: "++",
            val: "3"
        },
        {
            label: "--",
            val: "4"
        },
        {
            label: "+-",
            val: "5"
        },
        {
            label: "+++",
            val: "6"
        },
        {
            label: "---",
            val: "7"
        }
    ],
    absoluteType: [{
            label: "是",
            val: "3"
        },
        {
            label: "否",
            val: "6"
        },
        {
            label: "不确定",
            val: "7"
        }
    ],
    numArr: [{
        label: "分",
        val: "1"
    }],
    soucePlatform: [{
        label: '科研平台',
        val: 'DSICM'
    }], 
    orderPayStatus: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '待支付',
          value: '1',
        },
        {
          label: '已支付',
          value: '2',
        },
        {
          label: '已取消',
          value: '3',
        },
        {
          label: '已退款',
          value: '4',
        },
        {
          label: '已完成',
          value: '7',
        },
        {
          label: '待退款',
          value: '8',
        },
      ],
}